import { createAsyncThunk } from '@reduxjs/toolkit';
import { actions as errorActions } from 'in-meeting-experience-ui-components/contexts/error/context';
export const createSidePanelClient = createAsyncThunk('google/createSidePanelClient', (_, thunkAPI) => thunkAPI.extra.googleApi.createAddonSession().then(session => session.createSidePanelClient()).catch(error => {
  errorActions.setExternalOutage({
    isExternalOutage: true
  });
  return thunkAPI.rejectWithValue(error);
}));
export const getMeetingId = createAsyncThunk('google/getMeetingId', (client, thunkAPI) => client.getMeetingInfo().then(info => info.meetingId).catch(error => {
  errorActions.setExternalOutage({
    isExternalOutage: true
  });
  return thunkAPI.rejectWithValue(error);
}));
export const getMeetingSpace = createAsyncThunk('google/getMeetingSpace', (spaceId, thunkAPI) => thunkAPI.extra.googleApi.getMeetingSpace(spaceId).catch(error => {
  errorActions.setExternalOutage({
    isExternalOutage: true
  });
  return thunkAPI.rejectWithValue(error);
}));
export const getConferenceRecord = createAsyncThunk('google/getConferenceRecord', (conferenceRecordId, thunkAPI) => thunkAPI.extra.googleApi.getConferenceRecord(conferenceRecordId).catch(error => {
  errorActions.setExternalOutage({
    isExternalOutage: true
  });
  return thunkAPI.rejectWithValue(error);
}));